<template>
<w-settings-content-template>
  <el-row slot="content">
    <el-row class="title-bar" type="flex" justify="space-between">
      <div class="vertical-center-box">
        <div class="title-h3 mr-r15">수집 데이터 목록</div>
      </div>
      <div class="vertical-center-box">
        <el-button class="mr-r4" type="primary" size="mini" :disabled="!changeFlag" @click="clickSaveButton">저장</el-button>
        <el-button class="mr-r4" size="mini" @click="cancelButton" :disabled="!changeFlag">취소</el-button>
      </div>
    </el-row>
    <el-table ref="retentionTableRef" class="group-grid box-table" :height="targetHeight" @cell-click="rowClicked" :data="groupGridData">
      <el-table-column type="expand">
        <template slot-scope="scope">
            <el-table :data="scope.row.data" class="box-table" height="100%" :show-header="false" >
              <el-table-column width="48px"></el-table-column>
              <el-table-column prop="basicinfoSubname" :formatter="subnameFormatter"></el-table-column>
              <el-table-column prop="basicinfoSubvalueInteger">
                <template slot-scope="child">
                  <w-input-component :target-data.sync="child.row" @check-change-flag="checkChangeFlag"></w-input-component>
                </template>
              </el-table-column>
              <el-table-column prop="count" :formatter="formatter"></el-table-column>
            </el-table>
        </template>
      </el-table-column>
      <el-table-column label="데이터 구분" prop="state">
      </el-table-column>
      <el-table-column label="설정 주기">
      </el-table-column>
      <el-table-column label="최대 설정 주기">
      </el-table-column>
    </el-table>
  </el-row>
</w-settings-content-template>
</template>

<script>
import forEach from 'lodash/forEach';
import { columnDefault } from '@/constants/table';
import WSettingsContentTemplate from '@/components/template/SettingsContentTemplate';
import cloneDeep from 'lodash/cloneDeep';
import transform from 'lodash/transform';
import isEqual from 'lodash/isEqual';
import isObject from 'lodash/isObject';
import OperationSettingsAPI from '@/api/settings/common/operation-settings';
import msgUtil from '@/utils/message';
import WInputComponent from './components/inputComponent';

export default {
  name: 'WDataRetentionRange',
  components: {
    WSettingsContentTemplate,
    WInputComponent,
  },
  data() {
    return {
      targetHeight: null,
      columnDefault,
      groupGridData: [
        {
          state: '통합 성능 통계',
          id: 'SDDESINDEX',
          data: [],
        },
        {
          state: '서버 로그',
          id: 'SDDSERVERLOG',
          data: [],
        },
        {
          state: '장애 이벤트 로그',
          id: 'SDDEVENTLOG',
          data: [],
        },
        {
          state: '네트워크 스냅샷',
          // id: 'SDDNETWORKSNAPSHOT',
          id: 'SNAPSHOTNMS',
          data: [],
        },
        {
          state: '장비 로그',
          id: 'SDDDEVICE',
          data: [],
        },
        {
          state: '일별 파티션 테이블 데이터',
          id: 'SDD_PARTITION_DAILY',
          data: [],
        },
      ],
      tableColumns: [
        {
          align: 'center',
          width: 48,
        },
        {
          prop: 'basicinfoSubname',
          width: 50,
        },
        {
          prop: 'basicinfoSubvalueInteger',
          editable: true,
          scopedSlot: 'input-slot',
        },
        {
          prop: 'count',
          width: 130,
          formatter: this.formatter,
        },
      ],
      groupGridOriginData: [],
      targetData: {},
      targetKey: 0,
      resultData: [],
      saveButtonFlag: false,
      changeFlag: false,
      selectedExpandRow: [],
    };
  },
  mounted() {
    // 수집 데이터 보유기간 테이블은 내부에 테이블이 위치하여 고정 높이가 불가피, explorer일 경우 고정 px을 주도록 협의하였음 (2020. 02. 12 Song)
    const browser = navigator.userAgent.toLowerCase();
    this.targetHeight = (navigator.appName === 'Netscape') && ((browser.indexOf('mise') !== -1) || (browser.indexOf('trident') !== -1)) ? '800px' : null;
    this.$nextTick(() => {
      this.loadData();
    });
  },
  methods: {
    loadData() {
      // init
      for (let i = 0; i < this.groupGridData.length; i += 1) {
        this.groupGridData[i].data = [];
      }
      /**
       *  basicinfo_id = SDDTARGET 대상들 조회 (+ SDDTARGETMAX 포함)
       *
       * @param  {[type]} record [description]
       * @return {[type]}        [description]
       * @author Song
       */
      OperationSettingsAPI.getResourceKeepingPeriodList().then((response) => {
        if (response.data.success) {
          // 매핑
          forEach(response.data.data, (value, key) => {
            const index = this.groupGridData.findIndex((targetData) => targetData.id === key);
            this.groupGridData[index].data = value;
          });
          this.groupGridOriginData = cloneDeep(this.groupGridData);
          this.checkChangeFlag();
        }
      });
    },
    // 최대 설정 주기 formatter
    formatter(row, column, value) {
      return `${value}${row.basicinfoSubunit}`;
    },
    clickSaveButton() {
      this.difference(this.groupGridData, this.groupGridOriginData);
      const target = '수집 데이터 보유 기간';
      const action = msgUtil.action.SAVE;
      OperationSettingsAPI.setResourceKeepingPeriodData(this.resultData).then((response) => {
        if (response.data.success) {
          this.$message(msgUtil.getResultMsgData(action, target, true));
          this.resultData = [];
          this.loadData();
        } else {
          this.$message(msgUtil.getResultMsgData(action, target, false));
        }
      }).catch(() => {
        this.$message(msgUtil.getResultMsgData(action, target, false));
      });
    },
    cancelButton() {
      this.groupGridData = cloneDeep(this.groupGridOriginData);
      this.checkChangeFlag();
    },
    difference(object, base) {
      return transform(object, (result, value, key) => {
        if (!isEqual(value, base[key])) {
          if (isObject(value) && isObject(base[key])) {
            this.targetData = value;
            this.targetKey = key;
            this.difference(value, base[key]);
          } else {
            // value
            this.resultData.push(this.targetData);
          }
        }
      });
    },
    checkChangeFlag() {
      this.changeFlag = !isEqual(this.groupGridData, this.groupGridOriginData);
    },
    // row를 클릭하였을 경우 해당 row에 expand 이벤트를 실행
    rowClicked(row) {
      this.$refs.retentionTableRef.toggleRowExpansion(row);
    },
    subnameFormatter(row) {
      if (row.basicinfoSubid === 'snapshot-nms') {
        return '네트워크 스냅샷';
      }
      return row.basicinfoSubname;
    },
  },
};
</script>

<style>
.group-grid .el-table__expanded-cell[class*='cell'] {
  padding: 0px !important;
}

.group-grid {
  /* background: #7b8196; */
  color: #fff;
  font-size: 14px;
  & .el-table__row.expanded {
    background: #7b8196;
  }
}

.group-grid tr.expanded td {
  background: #7b8196;
  color: #fff;

}

.group-grid tr.expanded:hover > td {
  background: #818698 !important;
  color: #fff;
}

.el-table__expanded-cell > .el-table {
  border:1px solid #c3c6d0;
  border-top: none;
  & td:last-child {
    border-bottom: none;
  }
}

.title-table {
  //padding: 10px 0px 10px 0px;
  padding-bottom: 10px
}
</style>



// WEBPACK FOOTER //
// src/views/settings/operation/CollectionSettings/DataRetentionRange/index.vue